import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-28" data-id="element-144" data-mp="1qalq4w8vplqd">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 text-center sm:flex-row sm:gap-14 sm:text-left" data-id="element-145" data-mp="1o2lq4y82a9za">
        <svg viewBox="0 0 200 200" className="h-40 w-40 shrink-0 -rotate-6 text-red-700 sm:h-44 sm:w-44" role="img" aria-label="7 天退款保證" data-id="element-146" data-mp="222wjc7wug0nm">
          <defs data-id="element-147" data-mp="19eqxtixyu7mq">
            <path id="guarantee-stamp-path" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" data-id="element-148" data-mp="19e7q0v214zmf" />
          </defs>
          <circle cx="100" cy="100" r="95" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-149" data-mp="14gpgp3k3oidw" />
          <circle cx="100" cy="100" r="64" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-150" data-mp="1j5lttf10klld" />
          <text fill="currentColor" fontSize="14" fontWeight="700" letterSpacing="2" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-151" data-mp="1ecsputdddhac">
            <textPath href="#guarantee-stamp-path" textLength="498" lengthAdjust="spacing" data-id="element-152" data-mp="qm6i737a1z0v">
              退款保證 · 安心購買 · 退款保證 · 安心購買 ·
            </textPath>
          </text>
          <text x="100" y="112" textAnchor="middle" fill="currentColor" fontSize="64" fontFamily="ui-serif, Georgia, serif" data-id="element-153" data-mp="oyqfacyku3l9">
            7
          </text>
          <text x="100" y="136" textAnchor="middle" fill="currentColor" fontSize="13" fontWeight="700" letterSpacing="3" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-154" data-mp="ypl0de036x54">
            天
          </text>
        </svg>

        <div data-id="element-155" data-mp="6175360duex9">
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-slate-900 sm:text-5xl" data-id="element-156" data-mp="61p5meu2vfaz">
            7 天退款保證
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slate-900/75" data-id="element-157" data-mp="b1us7glhqbm7">
            下載教材，親身試用。如果教材不符合你的期望，可以在購買後 7 天內電郵聯絡我們，按保證條款申請退款。
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-900/60" data-id="element-158" data-mp="k1hs1xykn9d5">
            本保證不影響你根據適用消費者法例享有的權利。
          </p>
        </div>
      </div>
    </section>;
}